import React, { useState, useContext } from 'react';
import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogActions, 
  Button, 
  Typography,
  Alert,
  CircularProgress,
  Box
} from '@mui/material';
import { Warning as WarningIcon } from '@mui/icons-material';
import { CONTEXTS, CONTROLLERS } from 'figshelf-modules';

const DeleteUserModal = ({ open, onClose, user, onUserDeleted }) => {
  const api = useContext(CONTEXTS.APIContext);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleDelete = async () => {
    setLoading(true);
    setError(null);

    try {
      const adminController = new CONTROLLERS.AdminController(api);
      await adminController.deleteUser(user.id);
      
      if (onUserDeleted) {
        onUserDeleted();
      }
      
      onClose();
    } catch (err) {
      console.error('Error deleting user:', err);
      setError(err.response?.data?.message || 'Failed to delete user');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <WarningIcon color="error" />
          Delete User
        </Box>
      </DialogTitle>
      <DialogContent>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        <Typography variant="body1" gutterBottom>
          Are you sure you want to delete this user?
        </Typography>
        <Box sx={{ mt: 2, p: 2, bgcolor: 'grey.100', borderRadius: 1 }}>
          <Typography variant="body2"><strong>Username:</strong> {user?.username}</Typography>
          <Typography variant="body2"><strong>Email:</strong> {user?.email}</Typography>
          <Typography variant="body2"><strong>Display Name:</strong> {user?.profile?.displayName || 'N/A'}</Typography>
        </Box>
        <Alert severity="warning" sx={{ mt: 2 }}>
          This action will soft delete the user. The user account will be marked as deleted but data will be retained.
        </Alert>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>Cancel</Button>
        <Button 
          onClick={handleDelete} 
          variant="contained" 
          color="error"
          disabled={loading}
          startIcon={loading && <CircularProgress size={20} />}
        >
          {loading ? 'Deleting...' : 'Delete User'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteUserModal;
